import { useMemo } from 'react';

import type { TypeSelectOption } from '@thefarmersfront/kitchen';

import { Table, TableBottomField, TableTopField } from '~/components/common';

import { getDeliveryAgencyCollectingRequestCandidatesColumnDefs } from '~/utils/delivery-agency/table';

import { DELIVERY_AGENCY_TRACKING_PAGE_SIZE } from '~/constants/delivery-agency';

import type { TypePagination } from '~/types/common.types';
import type { CollectingOutboundListItem } from '~/types/delivery-agency.types';

import styles from './CollectingRequestCandidateTable.module.scss';

const CollectingRequestCandidateTable = ({
  data,
  pagination,
  onChangePageLimit,
  onChangePage,
  onChangeRowSelection,
}: {
  data: CollectingOutboundListItem[] | null;
  pagination: TypePagination;
  onChangePageLimit: (value: TypeSelectOption<number>) => void;
  onChangePage: (value: number) => void;
  onChangeRowSelection: (rows: CollectingOutboundListItem[]) => void;
}) => {
  const { columnDefs } = useMemo(
    () =>
      getDeliveryAgencyCollectingRequestCandidatesColumnDefs({
        currentPage: pagination.currentPage - 1,
        pageSize: pagination.pageSize,
      }),
    [pagination.currentPage, pagination.pageSize]
  );

  return (
    <div className={styles['table-container']}>
      <TableTopField dataTotalCount={pagination.totalCount} />

      <div className={styles['table-wrapper']}>
        <Table
          data={data}
          options={{ columnDefs, rowSelection: 'single' }}
          rowStatusType={data === null ? 'INIT' : 'COLLECTING_CANDIDATE_EMPTY'}
          onSelectionChange={(nodes) =>
            onChangeRowSelection(
              nodes.map((node) => node.data).filter((row): row is CollectingOutboundListItem => Boolean(row))
            )
          }
        />
      </div>

      <TableBottomField
        pageSizeOptions={Object.values(DELIVERY_AGENCY_TRACKING_PAGE_SIZE)}
        currentPage={pagination.currentPage - 1}
        totalCount={pagination.totalCount}
        pageSize={pagination.pageSize}
        onChangePageLimit={onChangePageLimit}
        onClickPage={(page) => onChangePage(page + 1)}
      />
    </div>
  );
};

export default CollectingRequestCandidateTable;
